import { Button } from "components/Interactive/Button";
import { Breadcrumbs } from "components/Navigation/Breadcrumbs";
import { ProfileDropdown } from "components/Navigation/ProfileDropdown";
import "./SiteHeader.styles.scss";
import { Route } from "constants/routes";
import { useRole } from "hooks/common";
import { useNavigate } from "react-router-dom";

export const SiteHeader: React.FC = () => {
  const navigate = useNavigate();
  const { isUserAdmin } = useRole();

  const adminBtnHandler = () => {
    navigate(Route.App.Admin.ROOT.path);
  };

  return (
    <header className="nb-layout-site-header">
      <div className="nb-layout-site-header-breadcrumbs">
        <Breadcrumbs />
      </div>
      <div className="nb-layout-site-header-controls">
        {/*TODO: Notifications logic*/}
        {/*<IconButton*/}
        {/*  variant="secondary"*/}
        {/*  icon={<Notifications />}*/}
        {/*  className="nb-layout-site-header-controls-notifications"*/}
        {/*/>*/}

        {isUserAdmin && (
          <Button
            className="nb-layout-site-header-adminBtn"
            variant="secondary"
            type="button"
            onClick={adminBtnHandler}
          >
            Адмін. панель
          </Button>
        )}
        <ProfileDropdown />
      </div>
    </header>
  );
};
